<!--
 * @Author: your name
 * @Date: 2021-04-20 11:57:04
 * @LastEditTime: 2021-08-09 15:06:54
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \yijiu_shopmall_h5\src\views\wallet.vue
-->
<template>
  <div class="wallet">
    <div class="wallet-fix">
      <div class="wallet-main">
        <div class="flex">
          <div class="wallet-top">
            <div>
              累计收益(元)
              <span
                class="iconfont iconwenhao3"
                @click="tipToastFg('可提现金额+待入账收益+线下收益+已提现收益!')"
              ></span>
            </div>
            <div class="flex-b wallet-box">
              <div class="wallet-size">{{walletInfo.income}}</div>
            </div>
          </div>
          <div class="wallet-top ml_nines">
            <div>
              可提现收益(元)
              <span class="iconfont iconwenhao3" @click="tipToastFg('已经结算完成，可以提取的收益！')"></span>
            </div>
            <div class="flex-b wallet-box">
              <div class="wallet-size">{{walletInfo.amount}}</div>
            </div>
          </div>
        </div>

        <div class="wallet-list flex-b">
          <div class="wallet-item">
            <div class="wallet-item-name">
              待结算收益(元)
              <span
                class="iconfont iconwenhao3"
                @click="tipToastFg('已经产生推广订单，但是订单尚未完结；如取消订单或退款将会扣减对应的余额!')"
              ></span>
            </div>
            <div class="wallet-item-num">{{walletInfo.unsettled}}</div>
          </div>
          <div class="wallet-item">
            <div class="wallet-item-name">
              线下收益(元)
              <span class="iconfont iconwenhao3" @click="tipToastFg('线下转让卡的收益记录！')"></span>
            </div>
            <div class="wallet-item-num">{{walletInfo.offline_price}}</div>
          </div>
          <div class="wallet-item">
            <div class="wallet-item-name">
              已提现收益（元）
              <span class="iconfont iconwenhao3" @click="tipToastFg('已经提现完成的收益金额！')"></span>
            </div>
            <div class="wallet-item-num">{{walletInfo.withdraw}}</div>
          </div>
        </div>
        <div class="wallet-btn" @click="goCashMoney">提现</div>
      </div>
      <!-- <div class="total-price">总支出：¥{{walletInfo.expenditure}} 总收入：¥{{walletInfo.total_income}}</div> -->
      <div class="switch-list flex-a">
        <div @click="switchFg(0)" :class="iskey == 0 ? 'key' :''">全部</div>
        <div @click="switchFg(1)" :class="iskey == 1 ? 'key' :''">支出</div>
        <div @click="switchFg(2)" :class="iskey == 2 ? 'key' :''">收入</div>
      </div>
    </div>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div class="wallet-record">
        <div class="record-once flex-b alitem_center" v-for="(item,index) in list" :key="index">
          <div>
            <div class="record-once-title once-l">{{item.trade_type_text}}</div>
            <div class="once-time">{{item.created_at}}</div>
          </div>
          <div>
            <div class="record-once-title">{{item.type == 1 ? '+' : '-'}}{{item.amount}}</div>
            <!-- <div class="once-btn apply">已申请</div> -->
            <!-- <div class="once-btn view" @click="jump(item.order_sn)">查看订单</div> -->
          </div>
        </div>
      </div>
    </van-list>
    <toastMune v-if="messageFile != ''" :isToast="isToast" :message="messageFile"></toastMune>
  </div>
</template>

<script>
import toastMune from '../components/toast.vue'
import { add } from '../public/floatPublic.js'
export default {
  components: { toastMune },
  data() {
    return {
      iskey: 0,
      list: [],
      page: 1,
      loading: false,
      finished: false,
      walletInfo: {},
      isToast: false,
      messageFile: '',
    }
  },
  created() {
    console.log(this.$route.query)
    this.getMyWalletInfo()
    this.getList()
  },
  mounted() {
    this.prohibitweixinShare()
  },
  methods: {
    tipToastFg(e) {
      this.messageFile = e
      this.isToast = true
      setTimeout(() => {
        this.isToast = false
      }, 3000)
    },
    switchFg(e) {
      this.list = []
      this.page = 1
      this.iskey = e
      this.getList()
    },
    // 异步更新数据
    onLoad() {
      this.page++
      this.getList()
    },
    //获取列表
    async getList() {
      let res = await this.http('ClientOrder.balanceChangeList', {
        page: this.page,
        type: this.iskey,
      })
      this.loading = false
      this.list = this.list.concat(res.content.list)
      this.finished = res.content.list.length == 0
    },
    //获取钱包信息
    async getMyWalletInfo() {
      let res = await this.http('Client.myWalletInfo', {})
      // amount
      // unsettled
      // income
      res.content.all_dollar = add(res.content.unsettled, res.content.income)
      this.walletInfo = res.content
      console.log(res)
    },
    //跳转
    jump(order_no) {
      console.log(order_no)
      this.$router.push({
        path: './orderDetails',
        query: { id: order_no },
      })
    },
    //去提现
    goCashMoney() {
      this.$router.push({ path: '/withdrawal' })
    },
  },
}
</script>

<style lang="scss" scoped>
.alitem_center {
  align-items: center;
}
.wallet {
  background: #f8f8f8;
  width: 100%;
  height: 100%;
  .wallet-fix {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 10;
    background: #f8f8f8;
    .wallet-main {
      width: 100vw;
      position: relative;
      height: 324px;
      background-image: url('../assets/img/wallet-bg.png');
      background-size: 100% 500px;
      background-repeat: no-repeat;
      background-position: 0 0;
      padding: 0 60px 0 30px;
      box-sizing: border-box;
      overflow: hidden;
      .wallet-btn {
        position: absolute;
        right: 0;
        top: 120px;
        width: 103px;
        height: 50px;
        background: #ffffff;
        border-radius: 32px;
        text-align: center;
        line-height: 50px;
        font-size: 28px;
        font-weight: 400;
        color: #ee0a24;
      }
      .ml_nines {
        margin-left: 138px;
      }
      .wallet-top {
        margin-top: 38px;
        font-size: 22px;
        font-weight: 400;
        color: #ffdde1;
        line-height: 22px;
        margin-bottom: 14px;
        .wallet-box {
          margin-top: 4px;
        }
        .wallet-size {
          font-size: 48px;
          font-weight: bold;
          color: #ffffff;
          line-height: 70px;
        }
      }
      .wallet-list {
        .wallet-item {
          margin-top: 60px;
          .wallet-item-name {
            font-size: 22px;
            font-weight: 400;
            color: #ffdde1;
            line-height: 22px;
          }
          .wallet-item-num {
            font-size: 32px;
            font-weight: bold;
            color: #ffffff;
            line-height: 48px;
            margin-top: 5px;
          }
        }
      }
    }
    .total-price {
      font-size: 26px;
      font-weight: 400;
      color: #969799;
      line-height: 26px;
      text-indent: 30px;
      margin-top: 32px;
      margin-bottom: 32px;
    }

    .switch-list {
      width: 710px;
      height: 88px;
      background: #ffffff;
      border-radius: 14px;
      margin: 0 auto;
      > div {
        font-size: 28px;
        font-weight: 400;
        color: #969799;
        line-height: 88px;
      }
      > div.key {
        color: #323233;
        position: relative;
      }
      > div.key::after {
        content: '';
        width: 80px;
        height: 6px;
        display: block;
        position: absolute;
        background: #ff3333;
        left: 50%;
        bottom: 0;
        transform: translate(-50%, 0);
      }
    }
  }

  .wallet-record {
    margin-top: 420px;
    background: #f8f8f8;
    border-top: 10px solid #f8f8f8;
    .record-once {
      width: 710px;
      height: 150px;
      padding: 22px 33px 28px 32px;
      box-sizing: border-box;
      margin: 30px auto;
      background: #ffffff;
      border-radius: 14px;
      .record-once-title {
        font-size: 38px;
        font-weight: 500;
        color: #333333;
        line-height: 38px;
      }
      .once-l {
        font-size: 32px;
        color: #323233;
        margin-top: 20px;
      }
      .once-time {
        font-size: 24px;
        font-weight: 400;
        color: #969799;
        margin-top: 10px;
      }
      .once-btn {
        width: 110px;
        height: 36px;
        border-radius: 18px;
        font-size: 24px;
        font-weight: 400;
        margin-top: 26px;
        text-align: center;
        line-height: 36px;
      }
      .apply {
        color: #ff9602;
        background: #ffecd2;
      }
      .view {
        color: #4983ff;
        background: #e3ecff;
      }
    }
  }
}
</style>
<style scope>
.van-list {
  background: none !important;
}
.iconwenhao3 {
  font-size: 30px;
  margin-left: 5px;
}
</style>